import {width} from '../utils/dimensions';

// get is mobile per fixed-data-table
var getDocumentProps = () => {
    var element = document.getElementsByClassName('main')[0];
    return {
        mainWidth: element ? width(element) : 0,
        windowInnerWidth: window.innerWidth,
        windowInnerHeight: window.innerHeight
    };
};


export default function documentProps(state = {}, action) {
    switch (action.type) {
        case 'PAGE_MOUNTED':
            return {
                ...state,
                mainWidth: action.mainWidth,
                windowInnerWidth: action.windowInnerWidth,
                windowInnerHeight: action.windowInnerHeight
            };
        case 'PAGE_RESIZED':
            return {
                ...state,
                mainWidth: action.mainWidth,
                windowInnerWidth: action.windowInnerWidth,
                windowInnerHeight: action.windowInnerHeight
            };
        default:
            return state;
    }
}

export function pageMounted() {
    return Object.assign({type: 'PAGE_MOUNTED'}, getDocumentProps());
}

export function pageResized() {
    return Object.assign({type: 'PAGE_RESIZED'}, getDocumentProps());
}


// WEBPACK FOOTER //
// ./app/reducers/documentProps.js